import React from 'react';

/**
 * A SETA DE ORDENAÇÃO das tabelas (09/10/2026): uma peça só, que eram quatro cópias iguais (Clientes, Produtos,
 * Assinaturas, DDRs) com a seta ativa em LARANJA, o acento velho. Na Central, estado é peso, não cor:
 *  - coluna ordenada: a seta (▲ crescente, ▼ decrescente) em `central-texto`, com peso;
 *  - coluna ordenável e não ordenada: ↕ em `central-texto-fraco`, para dizer que a coluna ordena. Antes ela não mostrava
 *    nada, e só se descobria clicando.
 * Decorativa para leitor de tela: quem diz a ordem é o `aria-sort` do cabeçalho, quando houver.
 */
export default function SortIcon({ dir }: { dir: 'asc' | 'desc' | false }) {
  if (!dir) return <span className='ml-1 inline-block text-central-texto-fraco' aria-hidden='true'>↕</span>;
  return (
    <span className='ml-1 inline-block text-central-texto font-semibold' aria-hidden='true' data-ordem={dir}>
      {dir === 'asc' ? '▲' : '▼'}
    </span>
  );
}
